let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("43bKP")).then(() => parcelRequire('5WuLD'));